// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"f47d5063","239":"06b68c1a","455":"e5a64ee4"}[chunkId] + ".chunk.js";
};